import { allBlockchainCoin } from '@/assets/static/currency-list'

export default {
  // Temporarily disabling 'All' option
  // getActiveBlockchain: state => state.activeBlockchain ?? allBlockchainCoin,
  getActiveBlockchain: state => state.activeBlockchain,
}